import React, { FC } from "react";
import PageLegalDocument from "containers/PageLegalDocument";

const PagePrivacyPolicy: FC = () => (
	<PageLegalDocument contentKey="privacyPolicyContent" titleI18nKey="nav.privacy_policy" />
);

export default PagePrivacyPolicy;
